import React from 'react';
import styled from 'styled-components';
import { IPageBuilderFooterPreviewProps } from './IPageBuilderFooterPreviewProps';
// import { Socials } from 'containers/PageBuilder/SinglePageContainer/domain';
// import Facebook from './socials/Facebook';
// import X from './socials/X';
// import LinkedIn from './socials/LinkedIn';
// import Instagram from './socials/Instagram';
// import Web from './socials/Web';
import { isValidHexColor } from 'components/PageBuilder/PageBuilderSideBar/BlockSettings/domain';
import { ButtonAction, scrollElementIntoView } from 'containers/PageBuilder/SinglePageContainer/domain';
import miscUtils from 'utils/miscUtils';
import useWindowSize from 'utils/windowSize';

const FooterContainer: any = styled.div<{design: any}>`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 50px;
    padding-bottom: 50px;
    background-color: ${(props) => 
        props.design.container_background_color &&
        isValidHexColor(props.design.container_background_color) ?
        props.design.container_background_color :
        'transparent'
    };

    &.mobile {
        padding-top: 25px;
        padding-bottom: 25px;
    }

    @media(max-width: 768px) {
        padding-top: 25px;
        padding-bottom: 25px;
    }
`;

const FooterContentContainer: any = styled.div<{design: any}>`
    width: 100%;
    max-width: ${(props) =>
        props.design.content_container_max_width ? 
        `${props.design.content_container_max_width}px` :
        `1150px`
    };
    padding-left: ${(props) => 
        props.design.container_padding_left ?
        `${props.design.container_padding_left}px` :
        `0px`
    };
    padding-right: ${(props) => 
        props.design.container_padding_right ?
        `${props.design.container_padding_right}px` :
        `0px`
    };
`;

const FooterWrapper: any = styled.div<{appDownloadShow: boolean}>`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 20px;

    @media(max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }

    &.mobile {
        flex-direction: column;
        align-items: center;
    }
`;

const FooterLeftContainer: any = styled.div`
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const FooterLogoImage: any = styled.img<{design: any}>`
    height: ${(props) => 
        props.design.logo_height ?
        `${props.design.logo_height}px`:
        `50px`
    };
    width: auto;
    cursor: pointer;
`;

const FooterCenterWrapper: any = styled.div<{appDownloadShow: any}>`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    @media(max-width: 768px) {
        position: unset;
        left: unset;
        transform: unset;
        margin-top: 20px;
    }

    &.mobile {
        position: unset;
        left: unset;
        transform: unset;
        margin-top: 20px;
    }
`;

const FooterCenterContainer: any = styled.div<{design: any, appDownloadShow: boolean, linksLength: number}>`
    display: grid;
    grid-template-columns: repeat(${(props) => 
        props.linksLength < 4 ?
        `${props.linksLength}` :
        '4'
    }, 1fr);
    column-gap: ${(props) => 
        props.design.link_margin ?
        `${props.design.link_margin}px` :
        `35px`
    };
    row-gap: 5px;
    width: fit-content;
    margin: 0 auto;

    @media(max-width: 768px) {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 0px;
    }

    &.mobile {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 0px;
    }
`;

const FooterCenterLink: any = styled.p<{design: any, index?: number}>`
    margin: 0;
    padding: 0;
    font-family: ${(props) => 
        props.design.link_text_font_family ?
        `${props.design.link_text_font_family} !important` :
        `-apple-system, Arial !important`
    };
    font-size: ${(props: any) =>
        props.design.link_text_font_size ?
        `${props.design.link_text_font_size}px` :
        `18px`
    };
    line-height: ${(props: any) =>
        props.design.link_text_line_height ?
        `${props.design.link_text_line_height}px` :
        `25px`
    };
    color: ${(props) => 
        props.design.link_text_color &&
        isValidHexColor(props.design.link_text_color) ?
        props.design.link_text_color :
        '#365DE6'
    };
    cursor: pointer;
    transition: .5s;
    margin-top: 10px;

    @media(max-width: 768px) {
        margin-top: ${(props) => 
            props.index ? 
            `20px` :
            '0'
        };
    }

    &.mobile {
        margin-top: ${(props) => 
            props.index ? 
            `20px` :
            '0'
        };
    }

    &:hover {
        color: ${(props) =>
            props.design.link_text_hover_color &&
            isValidHexColor(props.design.link_text_hover_color) ?
            props.design.link_text_hover_color :
            props.design.link_text_color &&
            isValidHexColor(props.design.link_text_color) ?
            props.design.link_text_color :
            `inherit`
        };
    }
`;

const FooterRightContainer: any = styled.div`
    display: flex;
    align-items: center;

    @media(max-width: 768px) {
        margin-top: 20px;
    }

    &.mobile {
        margin-top: 20px;
    }
`;

// const FooterRightIconContainer: any = styled.div`
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     cursor: pointer;
//     margin-left: 15px;
// `;

const FooterMetaContainer: any = styled.div<{design: any, desktop?: boolean}>`
    width: 100% !important;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: fit-content;
    align-items: center;
    justify-content: center;
    margin-top: ${(props) => 
        props.desktop ? 
        `40px` :
        `10px`
    };
    padding: 40px 0;
    border-top-width: ${(props) =>
        props.design.meta_container_border_top_width ?
        `${props.design.meta_container_border_top_width}px` :
        `0px`
    };
    border-top-style: solid;
    border-top-color: ${(props) =>
        props.design.meta_container_border_top_color &&
        isValidHexColor(props.design.meta_container_border_top_color) ?
        props.design.meta_container_border_top_color :
        `#666666`
    };

    @media(max-width: 768px) {
        flex-direction: column;
        padding-bottom: 0px;
    }

    &.mobile {
        flex-direction: column;
        padding-bottom: 0px;
    }
`;

const FooterMetaLink: any = styled.p<{design: any, index?: number}>`
    margin: 0;
    padding: 0;
    font-family: ${(props) => 
        props.design.link_text_font_family ?
        `${props.design.link_text_font_family} !important` :
        `-apple-system, Arial !important`
    };
    font-size: ${(props: any) =>
        props.design.link_text_font_size ?
        `${props.design.link_text_font_size}px` :
        `18px`
    };
    line-height: ${(props: any) =>
        props.design.link_text_line_height ?
        `${props.design.link_text_line_height}px` :
        `25px`
    };
    color: ${(props) => 
        props.design.link_text_color &&
        isValidHexColor(props.design.link_text_color) ?
        props.design.link_text_color :
        '#365DE6'
    };
    cursor: pointer;
    margin-left: ${(props) => 
        props.index ?
        `25px` :
        `0px`
    };

    @media(max-width: 768px) {
        margin-left: 0;
        margin-top: ${(props) => 
            props.index ? 
            `20px` :
            '0'
        };
    }

    &.mobile {
        margin-left: 0;
        margin-top: ${(props) => 
            props.index ? 
            `20px` :
            '0'
        };
    }
`;

const FooterAppDownloadContainer: any = styled.div`
    width: fit-content;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: fit-content;
    align-items: center;
    justify-content: center;


    @media(max-width: 550px) {
        margin-top: 20px;
    }

    &.mobile {
        margin-top: 20px;
    }
`;

const FooterAppDownloadLabel: any = styled.p<{design: any}>`
    margin: 0;
    padding: 0;
    margin-bottom: 10px;
    font-family: ${(props) => 
        props.design.label_text_font_family ?
        `${props.design.label_text_font_family} !important` :
        `-apple-system, Arial !important`
    };
    font-size: ${(props: any) =>
        props.design.label_text_font_size ?
        `${props.design.label_text_font_size}px` :
        `18px`
    };
    line-height: ${(props: any) =>
        props.design.label_text_line_height ?
        `${props.design.label_text_line_height}px` :
        `25px`
    };
    color: ${(props) => 
        props.design.label_text_color &&
        isValidHexColor(props.design.label_text_color) ?
        props.design.label_text_color :
        '#000000'
    };
`;

const FooterAppDownloadImage: any = styled.img<{design: any, marginLeft: boolean, index: number}>`
    cursor: pointer;
    margin-top: ${(props) => 
        props.index ?
        '15px' :
        '0px'
    };
    height: auto;
    width: ${(props) =>
        props.design.app_download_image_width ?
        `${props.design.app_download_image_width}px` :
        `120px`
    };
`;

const RESPONSIVE_BREAKPOINT: number = 768;

const PageBuilderFooterPreview: React.FC<IPageBuilderFooterPreviewProps> = (props) => {

    const windowSize = useWindowSize();

	const ctaOnClick = (blockData: any, clickableKey: string, useLink?: boolean) => {
		if(props.buildingPreview) {
			return;
		}
	
		if(
			blockData &&
			(
				blockData[`${clickableKey}_action`] === ButtonAction.URL ||
				blockData[`${clickableKey}_action`] === ButtonAction.URLTab
			) &&
			blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]
		) {
			window.open(
				miscUtils.ensureHttps(blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]), 
				blockData[`${clickableKey}_action`] === ButtonAction.URLTab ?
				'_blank' :
				'_self'
			);
			return;
		}
	
		if(
			blockData &&
			blockData[`${clickableKey}_action`] === ButtonAction.Scroll &&
			blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`] &&
			props.containerBaseIdName
		) {
			scrollElementIntoView(`${props.containerBaseIdName}${blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]}`);
			return;
		}
	
		if(
			blockData &&
			blockData[`${clickableKey}_action`] === ButtonAction.Popup &&
			blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]
		) {
			let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));
	
			nextPageFormsOpenState[blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]] = true;
	
			props.setPageFormsOpenState(nextPageFormsOpenState);
            return;
		}

        if(
            blockData &&
            blockData[`${clickableKey}_action`]  === ButtonAction.Page &&
            blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`] 
        ) {
            window.open(
                `${blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]}`,
                '_self'
            );
            return;
        }
	}
    
    // const getFooterRightIcon = (social: any) => {
    //     switch(social.type) {
    //         case Socials.Facebook:
    //             return (
    //                 <Facebook
    //                 width={props.footerData.design.social_icon_size}
    //                 height={props.footerData.design.social_icon_size}
    //                 fill={props.footerData.design.social_icon_color}
    //                 />
    //             );
    //         case Socials.X:
    //             return (
    //                 <X
    //                 width={props.footerData.design.social_icon_size}
    //                 height={props.footerData.design.social_icon_size}
    //                 stroke={props.footerData.design.social_icon_color}
    //                 />
    //             );
    //         case Socials.LinkedIn:
    //             return (
    //                 <LinkedIn
    //                 width={props.footerData.design.social_icon_size}
    //                 height={props.footerData.design.social_icon_size}
    //                 fill={props.footerData.design.social_icon_color}
    //                 />
    //             )
    //         case Socials.Instagram:
    //             return (
    //                 <Instagram
    //                 width={props.footerData.design.social_icon_size}
    //                 height={props.footerData.design.social_icon_size}
    //                 stroke={props.footerData.design.social_icon_color}
    //                 />
    //             )
    //         case Socials.Website:
    //             return (
    //                 <Web
    //                 width={props.footerData.design.social_icon_size}
    //                 height={props.footerData.design.social_icon_size}
    //                 fill={props.footerData.design.social_icon_color}
    //                 />
    //             )
    //         default:
    //             return <></>
    //     }
    // }

  return (
    <FooterContainer
    className={props.view ? `${props.view}` : ''}
    design={props.footerData.design}
    >
        <FooterContentContainer
        design={props.footerData.design}
        >
            <FooterWrapper
            className={props.view ? `${props.view}` : ''}
            appDownloadShow={props.footerData.app_download.show}
            >
                <FooterLeftContainer
                >
                    <FooterLogoImage
                    src={props.footerData.left.logo_url}
                    design={props.footerData.design}
                    onClick={() => ctaOnClick(props.footerData.left, 'image', true)}
                    />
                </FooterLeftContainer>

                <FooterCenterWrapper
                className={props.view ? `${props.view}` : ''}
                appDownloadShow={props.footerData.app_download.show}
                >
                    <FooterCenterContainer
                    className={props.view ? `${props.view}` : ''}
                    design={props.footerData.design}
                    appDownloadShow={props.footerData.app_download.show}
                    linksLength={props.footerData.center.links.length}
                    >
                        {props.footerData.center.links.map((link: any, index: number) => (
                            <FooterCenterLink
                            key={link.render_id}
                            className={props.view ? `${props.view}` : ''}
                            design={props.footerData.design}
                            index={index}
                            onClick={() => ctaOnClick(link, 'link')}
                            >
                                {link.link_text}
                            </FooterCenterLink>
                        ))}
                    </FooterCenterContainer>

                    {props.footerData.meta.show && windowSize.width > RESPONSIVE_BREAKPOINT && props.view !== 'mobile' ? (
                        <FooterMetaContainer
                        design={props.footerData.design}
                        desktop
                        className={props.view ? `${props.view}` : ''}
                        >
                                {props.footerData.meta.links.map((link: any, index: number) => (
                                    <FooterMetaLink
                                    key={link.render_id}
                                    className={props.view ? `${props.view}` : ''}
                                    design={props.footerData.design}
                                    index={index}
                                    onClick={() => ctaOnClick(link, 'link')}
                                    >
                                        {link.link_text}
                                    </FooterMetaLink>
                                ))}
                        </FooterMetaContainer>
                    ) : <></>}
                </FooterCenterWrapper>

                <FooterRightContainer
                className={props.view ? `${props.view}` : ''}
                >
                    {/* {props.footerData.right.socials.map((social: any, index: number) => (
                        <FooterRightIconContainer
                        >
                            {getFooterRightIcon(social)}
                        </FooterRightIconContainer>
                    ))} */}
                        {props.footerData.app_download.show ? (
                            <FooterAppDownloadContainer
                            className={props.view ? `${props.view}` : ''}
                            >
                                {
                                    props.footerData.app_download.title &&
                                    props.footerData.app_download.title.trim() !== "" ?
                                    <FooterAppDownloadLabel
                                    design={props.footerData.design}
                                    >
                                        {props.footerData.app_download.title}
                                    </FooterAppDownloadLabel> : <></>
                                }
                                {props.footerData.app_download.links.map((link: any, index: number) => (
                                    <FooterAppDownloadImage
                                    key={`${index}`}
                                    design={props.footerData.design}
                                    className={props.view ? `${props.view}` : ''}
                                    src={link.image_url}
                                    marginLeft={!!index}
                                    index={index}
                                    onClick={() => ctaOnClick(link, 'link')}
                                    />
                                ))}
                            </FooterAppDownloadContainer>
                        ) : <></>}
                </FooterRightContainer>
            </FooterWrapper>
            {props.footerData.meta.show && (windowSize.width <= RESPONSIVE_BREAKPOINT || props.view === 'mobile') ? (
                <FooterMetaContainer
                design={props.footerData.design}
                className={props.view ? `${props.view}` : ''}
                >
                        {props.footerData.meta.links.map((link: any, index: number) => (
                            <FooterMetaLink
                            key={link.render_id}
                            className={props.view ? `${props.view}` : ''}
                            design={props.footerData.design}
                            index={index}
                            onClick={() => ctaOnClick(link, 'link')}
                            >
                                {link.link_text}
                            </FooterMetaLink>
                        ))}
                </FooterMetaContainer>
            ) : <></>}
        </FooterContentContainer>
    </FooterContainer>
  )
}

export default PageBuilderFooterPreview;